import { getFolderName } from './embedCodeParams';
import { featureFlags } from './featureFlags';

interface Logger {
  debug: (...args: unknown[]) => void;
  log: (...args: unknown[]) => void;
  warn: (...args: unknown[]) => void;
  error: (...args: unknown[]) => void;
}

const logger: Logger = {
  debug: (...args: unknown[]) => {
    const folderName = getFolderName();

    if (featureFlags.logs) {
      // eslint-disable-next-line no-console
      console.debug(`=== w ${folderName} debug ===\n`, ...args);
    }
  },
  log: (...args: unknown[]) => {
    const folderName = getFolderName();

    if (featureFlags.logs) {
      // eslint-disable-next-line no-console
      console.log(`=== w ${folderName} log ===\n`, ...args);
    }
  },
  warn: (...args: unknown[]) => {
    const folderName = getFolderName();

    if (featureFlags.logs) {
      // eslint-disable-next-line no-console
      console.warn(`=== w ${folderName} warn ===\n`, ...args);
    }
  },
  error: (...args: unknown[]) => {
    const folderName = getFolderName();

    // eslint-disable-next-line no-console
    console.error(`=== w ${folderName} error ===\n`, ...args);
  },
};

export default logger;
